import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-detail',
  templateUrl: './info-detail.component.html',
  styleUrls: ['./info-detail.component.scss']
})
export class InfoDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
